import React, { useState } from 'react';
import { getPublicFolderPath } from '../../../utils';
import { BankType } from '../../../Types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '../../BuildingBlocks/Card/Card';
import Typography from '@material-ui/core/Typography';
import { useMobile } from 'frontend/src/hooks/useMobile';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    width: '100%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  rightCard: { marginLeft: theme.spacing(1.5) },
  leftCard: { marginRight: theme.spacing(1.5) },
  content: {
    height: 180,
    width: 180,
    [theme.breakpoints.down('sm')]: {
      height: 160,
      width: 140,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    maxHeight: 40,
  },
  bold: { fontWeight: 'bold' },
  provider: { color: theme.palette.brand.greenNature },
}));

export default function ChooseBankOptionCards({
  loading,
  setBankType,
}: {
  loading: boolean;
  setBankType: (args: BankType) => any;
}) {
  const mobile = useMobile('sm');
  const classes = useStyles();
  const [options, setOptions] = useState([
    {
      id: BankType.plaid,
      active: false,
      img: '/icons/bank.svg',
      imgAlt: 'Bank icon',
      type: 'US-based Bank',
      provider: 'Plaid',
    },
    {
      id: BankType.wise,
      active: false,
      img: '/third-party/wise-logo.svg',
      imgAlt: 'Wise logo',
      type: 'Wise',
      provider: 'Nordigen',
    },
  ]);

  function onSelect(type: BankType) {
    const updatedOptions = options.map((option) => {
      if (option.id === type) {
        option.active = true;
      } else {
        option.active = false;
      }
      return option;
    });
    setOptions(updatedOptions);
    setBankType(type);
  }

  return (
    <div className={classes.root}>
      {options?.map((option, i) => {
        return (
          <div
            className={classes[i === 0 ? 'leftCard' : 'rightCard']}
            key={option.id}
          >
            <Card
              id={option.id}
              isActive={option.active}
              disabled={loading}
              onClick={() => onSelect(option.id)}
            >
              <div className={classes.content}>
                <img
                  src={
                    getPublicFolderPath(window.location.pathname) + option.img
                  }
                  alt={option.imgAlt}
                  className={classes.icon}
                />
                <Typography
                  variant={mobile ? 'subtitle2' : 'h6'}
                  className={classes.bold}
                >
                  {option.type}
                </Typography>
                <Typography
                  variant="subtitle2"
                  paragraph
                  className={classes.provider}
                >
                  via {option.provider}
                </Typography>
              </div>
            </Card>
          </div>
        );
      })}
    </div>
  );
}
